import React, { useEffect } from "react";
//@ts-ignore
import FileIcon from "../../../../assets/images/file.png";
import { Search } from "lucide-react";
import CustomInput from "../../../../components/CustomInput/CustomInput";
import { useForm } from "react-hook-form";
import LoadingAnimation from "../../../../assets/svg/LoadingAnimation";
import { colors } from "../../../../utils/theme";
import { isNullOrEmpty } from "../../../../utils/helperFunction";
import { useSnackbar } from "notistack";
import { SearchHiringCompanyCompaniesFields } from "./searchRecruitmentAgencies.types";
import {
  addRecruiterAsPartner,
  recruitersList,
} from "../../../../endpoints/hiringCompany/requirements";
import dayjs from "dayjs";

const SearchRecruitmentAgencies: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const {
    control,
    formState: { errors },
    setValue,
    watch,
  } = useForm<SearchHiringCompanyCompaniesFields>({
    defaultValues: {
      isSubmitting: [],
      data: [],
      isLoading: true,
    },
  });
  const fields = watch();

  const onInvite = async (id: string) => {
    try {
      setValue("isSubmitting", [...fields?.isSubmitting, id]);
      const response = await addRecruiterAsPartner({
        recruiterId: id,
      });
      if (response?.success) {
        const find = fields?.data?.findIndex((x) => x._id === id);
        let newData = fields?.data;
        newData[find] = { ...newData[find], invited: true };
        setValue("data", [...newData]);
        enqueueSnackbar(response?.data?.message, {
          variant: "success",
        });
      }
    } catch (error) {
      console.error(error, "error");
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
      setValue(
        "isSubmitting",
        fields?.isSubmitting?.filter((x) => x !== id)
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [fields?.search]);

  const fetchData = async () => {
    try {
      const response = await recruitersList({
        limit: 1000,
        page: 1,
        ...(!isNullOrEmpty(fields?.search) && {
          firstName: fields?.search?.trim(),
        }),
      });

      setValue("data", response?.data);
    } catch (error) {
    } finally {
      setValue("isLoading", false);
    }
  };

  if (fields?.isLoading && isNullOrEmpty(fields?.data)) {
    return (
      <div className="flex flex-col rounded-lg bg-white w-full flex-grow p-6 justify-center items-center">
        <LoadingAnimation color={colors.PrimaryBlack} />
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <div className="flex  items-center justify-between w-full gap-8 bg-[#F1F5F9] rounded-lg px-3 py-3 my-5">
        <div className="relative w-1/3">
          {/* @ts-ignore */}
          <CustomInput
            name="search"
            control={control}
            className="border-none"
            errors={errors}
            placeholder="Search by company name..."
            renderRight={<Search color="#6F6F6F" width={16} />}
          />
        </div>
      </div>
      {!isNullOrEmpty(fields?.data) ? (
        <div className="w-[100%] h-[100%] overflow-y-scroll no-scrollbar">
          <table className="min-w-full text-xs text-left">
            <thead className="border-b border-[#E0E0E0]">
              <tr className="font-semibold">
                <th className="py-3 text-xs font-bold text-[#6F6F6F]">
                  Recruitment Agent
                </th>
                <th className="py-3 text-xs font-bold text-[#6F6F6F]">
                  Category
                </th>
                <th className="py-3 text-xs font-bold text-[#6F6F6F]">
                  Working since
                </th>
                <th className="py-3 text-xs font-bold text-[#6F6F6F] text-center">
                  Total hires
                </th>
                <th className="py-3 text-xs font-bold text-[#6F6F6F]">
                  Location
                </th>
                <th />
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {fields?.data?.map((agent, idx) => (
                <tr
                  key={idx}
                  className="border-t  border-gray-100 cursor-pointer hover:bg-gray-50"
                >
                  <td className="text-xs font-medium text-[#6F6F6F] ">
                    <div className="flex gap-2 items-center">
                      <div
                        className={`h-8 w-8 rounded-full justify-center items-center flex bg-nwhited ${
                          !agent?.profilePic && "bg-[#E1E0E0]"
                        }`}
                      >
                        {agent?.profilePic ? (
                          <img
                            src={agent?.profilePic}
                            className="h-full w-full object-cover rounded-full"
                            alt="hiringCompany_profilePic"
                          />
                        ) : (
                          <span className="font-montserrat text-white font-semibold text-sm uppercase">
                            {agent?.firstName?.charAt(0)}
                          </span>
                        )}
                      </div>
                      {agent?.firstName} {agent?.lastName}
                    </div>
                  </td>
                  <td className="py-6 text-xs font-medium text-[#6F6F6F]">-</td>
                  <td className="py-6 text-xs text-[#6F6F6F]">
                    {dayjs(agent?.createdAt).format("MMMM DD, YYYY")}
                  </td>
                  <td className="py-6 text-xs text-[#6F6F6F] text-center">
                    {agent?.totalHires}
                  </td>
                  <td className="py-6 text-xs font-medium text-[#6F6F6F]">
                    {isNullOrEmpty(agent?.location) ? "-" : agent?.location}
                  </td>
                  <td>
                    <button
                      onClick={() => onInvite(agent._id)}
                      className={`text-[10px] font-medium min-w-28 bg-[#F1F5F9] text-[#4D4D4D] border border-[#4D4D4D] py-1.5 px-4 relative rounded flex justify-center mr-2 items-center justify-self-end ${
                        agent.invited === true ? "opacity-50" : "opacity-100"
                      }`}
                    >
                      {fields.isSubmitting?.includes(agent?._id) ? (
                        <div className="flex h-5 w-5 ">
                          <LoadingAnimation
                            color={colors.PrimaryBlack}
                            className="mr-0 h-5 w-5 absolute ml-0"
                          />
                        </div>
                      ) : agent.invited === true ? (
                        "Invited"
                      ) : (
                        "Add to partner"
                      )}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center flex-1 text-center">
          <img src={FileIcon} alt="File Icon" className="w-48 h-48" />
          <p className="text-xs text-[#6F6F6F] font-medium mt-4">
            No search result found!
          </p>
        </div>
      )}
    </div>
  );
};

export default SearchRecruitmentAgencies;
